import React, { Component } from 'react'
import { Content, Container, Writting, Images, Image, Label } from './styles'
import Video from '../Video'

class Project extends Component {
  render() {
    let { project } = this.props

    return(
      <Content>
        <Container>
          { project.content.map( (content, index) => {
            switch (content.type) {
              case "text":
                let writting = content.writting.map( (writting, index) => {
                  return(
                    <Writting key={index}>
                      <h2>{writting.title}</h2>
                      <p>{writting.text}</p>
                    </Writting>
                  )
                })
                return writting
              case "image":
                let images = content.images.map( (image, index) => {
                  return(
                    <Image src={image} key={index}/>
                  )
                })
                return <Images key={index}>{images}</Images>
              case "youtube":
                let videos = content.ytVideos.map( (video, index) => {
                  return(<Video videoId={video.videoId} key={index}/>)
                })
                return videos
              default:
                return(
                  <Writting key={index}>
                    <h2>An empty folder.</h2>
                    <p>This project is blank</p>
                  </Writting>
                )
            }
          })}
        </Container>
        <Label>
          <h2>{project.title}, {project.year}</h2>
        </Label>
      </Content>
    )
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/Components/Project/index.js